import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 16px;
    background: white;
    border: 1px solid #eaeaea;
    cursor: pointer;
    transition: all 0.25s ease;
    user-select: none;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
        border-color: #006a61;
    }
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 20px 22px 10px;
`;

export const AvatarWrapper = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 2px solid #e8e8e8;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
`;

export const MeetingTitle = styled.p`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: #1a1a1a;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Username = styled.p`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 13px;
    color: #888;
    margin: 3px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Description = styled.p`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.55;
    color: #555;
    margin: 0;
    padding: 6px 22px 18px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
`;

export const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 22px;
    border-top: 1px solid #f2f2f2;
    background: #fafafa;
    gap: 10px;
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
`;

export const Tag = styled.span`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #006a61;
    background: #e6f3f1;
    padding: 4px 10px;
    border-radius: 6px;
    white-space: nowrap;
`;

export const FreeTag = styled(Tag)`
    color: #2e7d32;
    background: #e8f5e9;
`;

export const PriceTag = styled(Tag)`
    color: #b45309;
    background: #fef3c7;
    font-weight: 600;
`;

export const ScheduleInfo = styled.span`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #999;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    cursor: help;
`;

export const OwnerBadge = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    background: #006a61;
    color: white;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 4px 10px;
    border-radius: 6px;
    z-index: 3;
`;
